import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../login/AuthContext';
import ProfilPicture from './ProfilPicture';
import { useNavigate } from 'react-router-dom';
import '../CreateCardForm/CreateCardForm.css';
import translations from '../../utils/language/translations.json';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

// const regex = {
//   ShowName: /^[A-Za-z0-9\s]{3,}$/i,
//   FirstName: /^[A-Za-z\s]{3,}$/i,
//   LastName: /^[A-Za-z\s]{3,}$/i,
//   Address: /^[A-Za-z0-9\s,'-]{3,}$/i,
//   City: /^[A-Za-zÀ-ÿ\s,'-]{3,}$/i,
//   State: /^[A-Za-z\s]{3,}$/i,
//   Country: /^[A-Za-z\s]{3,}$/i,
//   ZipCode: /^(?:\d{5}(?:[-\s]\d{4})?|[A-Z]\d[A-Z]\d[A-Z]\d)$/,
//   Phone: /^\(\d{3}\)-\d{3}-\d{4}$/,
//   EbayProfile: /^https?:\/\/(?:www\.)?ebay\.(?:ca|com)\/usr\/[a-zA-Z0-9_.-]+$/i,
//   FacebookProfile: /^(http(s)?:\/\/)?(www\.)?facebook\.(com|ca)\/[a-zA-Z0-9.]+$/i,
// };

const EditProfilForm = () => {
  const { userId,liveCsrfToken} = useContext(AuthContext);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    Description: '',
    CurrentPassword: '',
    NewPassword: '',
    ShowName: '',
    FirstName: '',
    LastName: '',
    Address: '',
    City: '',
    State: '',
    Country: '',
    ZipCode: '',
    Phone: '',
    EbayProfile: '',
    FacebookProfile: '',
    ComCProfile: '',
    EpackProfile: '',
    TwitterProfile: '',
    InstagramProfile: '',
    ProfilePicture: '',
  });

  const { t: translate, i18n } = useTranslation(); 
  const currentLang = i18n.language; 
  const t = (key) => translations.EditProfilForm[key][currentLang]; 

  const [errors, setErrors] = useState({});

  // const validateFields = () => {
  //   const newErrors = {};
  //   for (const field in regex) {
  //     console.log('field',field)
  //     if (!regex[field].test(formData[field])) {
  //       newErrors[field] = `${t(field)} ${t('is invalid')}`;
  //     }
  //   }
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  // const handleInputChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  //   setErrors({ ...errors, [e.target.name]: '' });
  // };

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 10) value = value.slice(0, 10);

    const formattedPhone = value.replace(/(\d{3})(\d{3})(\d{4})/, '($1)-$2-$3');
    setFormData({ ...formData, Phone: formattedPhone });
    setErrors({ ...errors, Phone: '' });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  
    // Remove field error when user starts typing
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '', 
    }));
  };

  useEffect(() => {
    if (userId === null) {
      navigate(`/login`);
    }
     else {
      const fetchUserData = async () => {
        try {
          const res = await fetch(`${process.env.REACT_APP_API_BASE}/getUser/${userId}`, {
            method: 'GET',
            credentials: 'include',
          });

          if (res.status === 401) {
            console.error('Unauthorized! Redirecting to login...');
            window.location.href = '/login';
            return;
          }

          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }

          const json = await res.json();
          setFormData({
            CurrentPassword: '',
            NewPassword: '',
            Description:json.Description,
            ShowName: json.ShowName,
            FirstName: json.FirstName,
            LastName: json.LastName,
            Address: json.Address,
            City: json.City,
            State: json.State,
            Country: json.Country,
            ZipCode: json.ZipCode,
            Phone: json.Phone,
            EbayProfile: json.EbayProfile,
            FacebookProfile: json.FacebookProfile,
            ComCProfile: json.ComCProfile,
            EpackProfile: json.EpackProfile,
            TwitterProfile: json.TwitterProfile,
            InstagramProfile: json.InstagramProfile,
            ProfilPicture: json.ProfilPicture,
           
          });
        } catch (error) {
          console.error('Error fetching user data:', error.message);
        }
      };

      fetchUserData();
    }
  }, [navigate, setFormData, userId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const currentPassword = formData.CurrentPassword;
    const newPassword = formData.NewPassword;
  
    const updatedData = {
      Description:formData.Description,
      ShowName: formData.ShowName,
      FirstName: formData.FirstName,
      LastName: formData.LastName,
      Address: formData.Address,
      City: formData.City,
      State: formData.State,
      Country: formData.Country,
      ZipCode: formData.ZipCode,
      Phone: formData.Phone,
      EbayProfile: formData.EbayProfile,
      FacebookProfile: formData.FacebookProfile,
      ComCProfile: formData.ComCProfile,
      EpackProfile: formData.EpackProfile,
      TwitterProfile: formData.TwitterProfile,
      InstagramProfile: formData.InstagramProfile,
      
    };
  
    const updatePassword = async (userId, currentPassword, newPassword) => {
      if (!currentPassword || !newPassword) return;
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE}/updatePassword/${userId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ CurrentPassword: currentPassword, NewPassword: newPassword }),
        });
  
        if (!res.ok) {
          const errorData = await res.json();
          throw new Error(errorData.message || 'Failed to update password');
        }
  
        toast.success(t('Password updated successfully'));
      } catch (error) {
        console.error('Error updating password:', error.message);
        toast.error(t('Error updating password'));
      }
    };
  
    const updateProfile = async (userId, updatedData) => {
      try {
        console.log('liveCsrfToken', liveCsrfToken);
        const res = await fetch(`${process.env.REACT_APP_API_BASE}/updateProfil/${userId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'x-csrf-token': liveCsrfToken,
          },
          credentials: 'include',
          body: JSON.stringify(updatedData),
        });
  
        const data = await res.json();
  
        if (!res.ok) {
          if (data.errors) {
            console.error('❌ Backend Validation Errors:', data.errors);
            // ✅ Store validation errors in React state
            const newErrors = {};
            data.errors.forEach(err => {
              newErrors[err.path] = err.msg; // Map error message to form field
            });
            setErrors(newErrors);
          } else {
            toast.error(t('Error updating profile'));
          }
          return;
        }
  
        toast.success(t('Profile updated successfully'));
        setErrors({}); // ✅ Clear previous errors on success
      } catch (error) {
        console.error('❌ Error updating profile:', error);
        toast.error(t('Error updating profile'));
      }
    };
  
    if (currentPassword && newPassword) {
      await updatePassword(userId, currentPassword, newPassword);
    }
  
    updateProfile(userId, updatedData).catch((error) => {
      console.log('Error updating profile:', error);
    });
  };
  


  if (formData === null) {
    return <div>Loading...</div>;
  } else {
    return (
      <>
        {userId===null ? (
          navigate('/login')
        ) : (
          <>
            <ProfilPicture currentPicture={formData.ProfilPicture} userId={userId} />


            <div>
<form onSubmit={handleSubmit} className="formEditProfil">
  {/* Description – full width */}
  <div className="form-group full">
    <label htmlFor="Description">{t("Description")}:</label>
    <textarea
      name="Description"
      placeholder={`${t("Enter your")} ${t("Description")}`}
      value={formData.Description}
      onChange={handleInputChange}
      className={errors.Description ? 'error' : ''}
      rows="5"
    />
    {errors.Description && <p className="error-message">{errors.Description}</p>}
  </div>

  {/* Show Name (left column) */}
  <div className="form-group">
    <label htmlFor="ShowName">{t("ShowName")}:</label>
    <input
      type="text"
      name="ShowName"
      value={formData.ShowName}
      onChange={handleInputChange}
      className={errors.ShowName ? 'error' : ''}
    />
    {errors.ShowName && <p className="error-message">{errors.ShowName}</p>}
  </div>

  {/* First Name (right column) */}
  <div className="form-group">
    <label htmlFor="FirstName">{t("FirstName")}:</label>
    <input
      type="text"
      name="FirstName"
      value={formData.FirstName}
      onChange={handleInputChange}
      className={errors.FirstName ? 'error' : ''}
    />
    {errors.FirstName && <p className="error-message">{errors.FirstName}</p>}
  </div>

  {/* Last Name (left) */}
  <div className="form-group">
    <label htmlFor="LastName">{t("LastName")}:</label>
    <input
      type="text"
      name="LastName"
      value={formData.LastName}
      onChange={handleInputChange}
      className={errors.LastName ? 'error' : ''}
    />
    {errors.LastName && <p className="error-message">{errors.LastName}</p>}
  </div>

  {/* Address – full width */}
  <div className="form-group full">
    <label htmlFor="Address">{t("Address")}:</label>
    <input
      type="text"
      name="Address"
      value={formData.Address}
      onChange={handleInputChange}
      className={errors.Address ? 'error' : ''}
    />
    {errors.Address && <p className="error-message">{errors.Address}</p>}
  </div>

  {/* City (left) */}
  <div className="form-group">
    <label htmlFor="City">{t("City")}:</label>
    <input
      type="text"
      name="City"
      value={formData.City}
      onChange={handleInputChange}
      className={errors.City ? 'error' : ''}
    />
    {errors.City && <p className="error-message">{errors.City}</p>}
  </div>

  {/* State (right) */}
  <div className="form-group">
    <label htmlFor="State">{t("State")}:</label>
    <input
      type="text"
      name="State"
      value={formData.State}
      onChange={handleInputChange}
      className={errors.State ? 'error' : ''}
    />
    {errors.State && <p className="error-message">{errors.State}</p>}
  </div>

  {/* Country (left) */}
  <div className="form-group">
    <label htmlFor="Country">{t("Country")}:</label>
    <input
      type="text"
      name="Country"
      value={formData.Country}
      onChange={handleInputChange}
      className={errors.Country ? 'error' : ''}
    />
    {errors.Country && <p className="error-message">{errors.Country}</p>}
  </div>

  {/* Zip (right) */}
  <div className="form-group">
    <label htmlFor="ZipCode">{t("ZipCode")}:</label>
    <input
      type="text"
      name="ZipCode"
      value={formData.ZipCode}
      onChange={handleInputChange}
      className={errors.ZipCode ? 'error' : ''}
    />
    {errors.ZipCode && <p className="error-message">{errors.ZipCode}</p>}
  </div>

  {/* Phone – your call: make it full or leave half */}
  <div className="form-group full">
    <label htmlFor="Phone">{t("Phone")}:</label>
    <input
      type="text"
      name="Phone"
      value={formData.Phone}
      onChange={handlePhoneChange}
      className={errors.Phone ? 'error' : ''}
    />
    {errors.Phone && <p className="error-message">{errors.Phone}</p>}
  </div>

  {/* Socials in pairs, left/right (Ebay/Facebook), (ComC/Epack), (Twitter/Instagram) */}
  {/* ...repeat same pattern... */}

  {/* Passwords in a row */}
  <div className="form-group">
    <label htmlFor="CurrentPassword">{t("CurrentPassword")}:</label>
    <input
      type="password"
      name="CurrentPassword"
      value={formData.CurrentPassword}
      onChange={(e) => setFormData({ ...formData, CurrentPassword: e.target.value })}
      className={errors.CurrentPassword ? 'error' : ''}
    />
    {errors.CurrentPassword && <p className="error-message">{errors.CurrentPassword}</p>}
  </div>

  <div className="form-group">
    <label htmlFor="NewPassword">{t("NewPassword")}:</label>
    <input
      type="password"
      name="NewPassword"
      value={formData.NewPassword}
      onChange={(e) => setFormData({ ...formData, NewPassword: e.target.value })}
      className={errors.NewPassword ? 'error' : ''}
    />
    {errors.NewPassword && <p className="error-message">{errors.NewPassword}</p>}
  </div>

  {/* Save */}
  <button type="submit" className="btn-baseBlue">{t("Save/Update")}</button>
</form>

</div>


          </>
        )}
      </>
    )
  }

}



export default EditProfilForm